module.exports = __webpack_public_path__ + "static/media/mountain.6bfbacd9.svg";